import './css/PurchaseOrderHeader.css';
import moment from 'moment';
import defaultShop from '../../../assets/default-shop.png';
import { environment } from 'src/environment/environment';
import { Util } from 'src/Util';

const PurchaseOrderHeader = (purchaseOrderData: any) => {
  console.log('purchaseOrderData', purchaseOrderData);
  const timestamp = purchaseOrderData.purchaseOrderData?.createdAt;
  const dateTime = moment(timestamp);
  return (
    <div className="header-wrapper">
      <div className="header-container">
        <div className="main-title">
          <div className="logo">
            <img
              src={
                purchaseOrderData.purchaseOrderData?.shopId.profileImageId == undefined
                  ? defaultShop
                  : environment.api_url +
                    '/api/public/file/' +
                    purchaseOrderData.purchaseOrderData?.shopId.profileImageId._id +
                    '/' +
                    purchaseOrderData.purchaseOrderData?.shopId.profileImageId.originalName
              }
              alt="Logo"
              className="logo-image"
            />
          </div>
          <div className="store-info">
            <h1 className="store-name">
              {purchaseOrderData.purchaseOrderData?.shopId.shopName}
            </h1>
            <p className="store-address">
              {purchaseOrderData.purchaseOrderData?.shopId.shopAddress}
            </p>
            <p className="store-phone">
              {Util.formatPhoneNumber(
                purchaseOrderData.purchaseOrderData?.shopId.phoneNumber
              )}
            </p>
          </div>
        </div>
      </div>
      <div className="purchaseOrder-top-bar">
        <div className="purchaseOrder-bar"></div>
        <div className="purchaseOrder-text">PURCHASE ORDER</div>
        <div className="purchaseOrder-bar02"></div>
      </div>
      
      <div className="purchaseOrder-primary-details">
        <div className="purchaseOrder-primary-details-01">
          <p>
            <strong>{purchaseOrderData.purchaseOrderData?.supplierId.supplierName}</strong>
          </p>
          <p>
            <strong>
              {Util.formatPhoneNumber(
                purchaseOrderData.purchaseOrderData?.supplierId.refNumber
              )}
            </strong>
          </p>
          {purchaseOrderData.purchaseOrderData?.supplierId.supplierPhoneNumber != null &&
            purchaseOrderData.purchaseOrderData?.supplierId.supplierPhoneNumber != undefined && (
              <p>
                <strong>{purchaseOrderData.purchaseOrderData?.supplierId.supplierPhoneNumber}</strong>
              </p>
            )}
          {purchaseOrderData.purchaseOrderData?.supplierId.companyName != null &&
            purchaseOrderData.purchaseOrderData?.supplierId.companyName != undefined && (
              <p>
                <strong>{purchaseOrderData.purchaseOrderData?.supplierId.companyName}</strong>
              </p>
            )}
           {purchaseOrderData.purchaseOrderData?.purchaseOrderNumber != null &&
            purchaseOrderData.purchaseOrderData?.purchaseOrderNumber != undefined && (
              <p>
                <strong>{purchaseOrderData.purchaseOrderData?.purchaseOrderNumber}</strong>
              </p>
            )}
          <p>
            <strong>
              {purchaseOrderData.purchaseOrderData?.createdBy &&
                  purchaseOrderData.purchaseOrderData?.createdBy.name != null
                ? `Cashier: ${purchaseOrderData.purchaseOrderData.createdBy.name}`
                : ''}
            </strong>
          </p>
          {purchaseOrderData.purchaseOrderData?.createdBy &&
            purchaseOrderData.purchaseOrderData?.createdBy.name != null && (
              <p>
                <strong>
                  Cashier: {purchaseOrderData.purchaseOrderData?.createdBy?.name}
                </strong>
              </p>
            )}
        </div>
        <div className="purchaseOrder-primary-details-02">
          <p>
            <strong>{dateTime.format('DD MMM YYYY')}</strong>
          </p>
          <p>
            <strong>{dateTime.format('h.mm a')}</strong>
          </p>
        </div>
      </div>
    </div>
  );
};
export default PurchaseOrderHeader;
